<template>
    <button
        :class="$attrs.class || 'ds-btn'"
        aria-live="assertive"
        :aria-busy="busy"
        :disabled="busy || disabled || null"
    >
        <DSPreloader v-if="busy" indicator />
        <span :class="busy ? 'busy' : 'idle'">
            <slot />
        </span>
    </button>
</template>

<script setup>
defineProps({
    busy: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});
</script>
